import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Layout from '@/views/layout'
import {
    getToken
} from '@/utils/auth'
import store from '@/store'
import {
    Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
NProgress.configure({
    showSpinner: false
})


// 静态路由
export const staticRoutes = [{
    path: '/404',
    component: () =>
        import ('@/views/error-page/404'),
    hidden: true
}, {
    path: '/401',
    component: () =>
        import ('@/views/error-page/401'),
    hidden: true
}, {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
            path: 'home',
            component: () =>
                import ('@/views/home/index'),
            name: 'home',
            meta: {
                title: '系统首页',
                icon: 'home',
                affix: true
            }
        },
        {
            path: 'recharge',
            component: () =>
                import ('@/views/home/components/recharge/index'),
            name: 'recharge',
            hidden: true,
            meta: {
                title: '充值',
                icon: '',
                affix: false
            }
        }
    ]
}, {
    path: '/login',
    component: () =>
        import ('@/views/login/index'),
    meta: {
        title: '用户登录',
        icon: '',
        affix: false
    },
    hidden: true
}]

// 动态路由
export const asyncRoutes = [{
    path: '/message',
    component: Layout,
    name: 'messageManager',
    alwaysShow: true,
    meta: {
        title: '消息管理',
        icon: 'msg',
    },
    children: [
        {
            path: 'send',
            component: () =>
                import ('@/views/message/send'),
            name: 'messageSend',
            meta: {
                title: '5G消息发送'
            }
        },{
            path: 'personalSend',
            component: () =>
                import ('@/views/message/personalSend'),
            name: 'personalSend',
            meta: {
                title: '5G视信发送'
            }
        },{
            path: 'limitSend',
            component: () =>
                import('@/views/message/limitSend'),
            name: 'limitMessageSend',
            meta: {
                title: '管控Chatbot发送'
            }
        },{
            path: 'specificMessageSend',
            component: () =>
                import ('@/views/message/specificMessage'),
            name: 'specificMessageSend',
            meta: {
                title: '个性化短信发送'
            }
        }, {
            path: 'history',
            component: () =>
                import ('@/views/message/history'),
            name: 'groupSendHistory',
            meta: {
                title: '发送记录'
            }
        },
        {
            path: 'uplink',
            component: () =>
                import ('@/views/chatbot/uplink'),
            name: 'uplink',
            meta: {
                title: '上行消息'
            }
        }, {
            path: 'keywords',
            component: () =>
                import ('@/views/message/keywords'),
            name: 'keywordsReply',
            meta: {
                title: '关键词回复'
            }
        }, {
            path: 'detail',
            component: () =>
                import ('@/views/message/detail'),
            name: 'sendDetail',
            meta: {
                title: '群发详情'
            },
            hidden: true
        }, {
            path: 'addkeyDetail',
            component: () =>
                import ('@/views/message/addkeydetils'),
            name: 'addkeyDetail',
            meta: {
                title: '关键词回复'
            },
            hidden: true
        },
        {
            path: 'addlimitkeydetils',
            component: () =>
                import ('@/views/message/addlimitkeydetils'),
            name: 'addlimitkeydetils',
            meta: {
                title: '管控关键词回复'
            },
            hidden: true
        },
        {
            path: 'keyDetail',
            component: () =>
                import ('@/views/message/keydetils'),
            name: 'keyDetail',
            meta: {
                title: '关键词回复'
            },
            hidden: true
        }
    ]
}, {
   path: '/normalYuexin',
   component: Layout,
   name: 'ptyuexiManager',
   alwaysShow: true,
   meta: {
       title: '阅信增值管理',
       icon: 'el-icon-goods'
   },

    children: [
        //普通阅信素材
    {
        path: 'CommonYueXinList',
        component: () =>
            import ('@/views/material/CommonYueXinList'),
        name: 'CommonYueXinList',
        meta: {
            title: '阅信（增值）素材'
        }
    },
        {
        path: 'CommonYueXin',
        component: () =>
            import ('@/views/template/AimTemplate'),
        name: 'CommonYueXin',
        meta: {
            title: '阅信（增值）模板'
        }
    },
    //     {
    //    path: 'myYuexinTemplate',
    //         component: () =>
    //             import('@/views/template/AimTemplate'),
    //         name: 'amiTemplate',
    //         meta: {
    //             title: '阅信（增值）模板'
    //         }
    //    },
    {
        path: 'CommonYueXinAdd',
        component: () =>
            import ('@/views/template/components/CommonYueXin/add'),
        name: 'CommonYueXinAdd',
        hidden: true,
        meta: {
            title: '新增阅信（增值）模板'
        }
    },{
        path: 'CommonYueXinLink',
        component: () =>
            import ('@/views/shortlink/CommonYueXinLink'),
        name: 'CommonYueXinLink',
        meta: {
            title: '阅信（增值）短链'
        }
    }, {
            path: 'CommonYueXinReport',
            component: () =>
                import('@/views/report/commYuxin'),
            name: 'CommonYueXinReport',
            meta: {
                title: '模板报表统计'
            }
        }
        ,{
       path: 'mobile-peng',
        component: () =>
            import('@/views/mobilepeng/querymobil'),
        name: "mobileColide",
        meta: {
           title: '阅信能力撞库'
        }
    }, {
        path: 'pengList',
        component: () =>
            import('@/views/mobilepeng/list'),
        name: 'mobileColideTask',
        meta: {
            title: '阅信能力撞库记录'
        }
    }
    ]
},{
    path: '/contact',
    component: Layout,
    name: 'contactManager',
    alwaysShow: true,
    meta: {
        title: '通讯录管理',
        icon: 'contact'
    },
    children: [{
        path: 'client-list',
        component: () =>
            import ('@/views/contact/index'),
        name: 'customerList',
        meta: {
            title: '通讯录列表'
        }
    }]
}, {
    path: '/chatbot',
    component: Layout,
    name: 'ChatbotManager',
    meta: {
        title: 'Chatbot管理',
        icon: 'chatbot'
    },
    children: [{
        path: 'company-identity',
        component: () =>
            import ('@/views/chatbot/CompanyIdentity'),
        name: 'Company-identity',
        meta: {
            title: '公司认证信息'
        }
    },{
        path: 'list',
        component: () =>
            import ('@/views/chatbot/index'),
        name: 'ChatbotList',
        meta: {
            title: 'Chatbot管理'
        }
    }
    // ,
    // {
    //     path: 'info',
    //     component: () =>
    //         import ('@/views/chatbot/info'),
    //     name: 'ChatbotInfo',
    //     meta: {
    //         title: 'Chatbot信息'
    //     }
    // }
    ,
    {
        path: 'certtpl',
        component: () =>
            import ('@/views/certtpl/index'),
        name: 'certtpl',
        meta: {
            title: '人证企证模版管理'
        }
    },

    {
        path: 'fixedMenu',
        component: () =>
            import ('@/views/chatbot/fixedMenu'),
        name: 'fixedMenuManager',
        meta: {
            title: '固定菜单管理'
        },
        hidden: true
    }]
}, {
    path: '/material',
    component: Layout,
    name: 'materialManager',
    alwaysShow: true,
    meta: {
        title: '素材管理',
        icon: 'material'
    },
    //普通素材列表
    children: [{
        path: 'Commonlist',
        component: () =>
            import ('@/views/material/CommonList'),
        name: 'CommonList',
        meta: {
            title: '5G消息素材列表'
        }
    },

    {
        path: 'yuexin5GSc',
        component: () =>
            import ('@/views/material/public'),
        name: 'yuexin5GSc',
        meta: {
            title: '5G阅信素材列表'
        }
    },
        {
            path: 'limitMaterial',
            component: () =>
                import('@/views/material/limitList'),
            name: 'limitMaterList',
            meta: {
                title: '管控Chatbot素材列表'
            }
        }
]
}, {
    path: '/template',
    component: Layout,
    name: 'templateManager',
    alwaysShow: true,
    meta: {
        title: '模板管理',
        icon: 'template'
    },
    children: [{
            path: 'list',
            component: () =>
                import ('@/views/template/index'),
            name: 'templateList',
            meta: {
                title: '5G消息模版列表'
            }
        },
        {
            path: 'card',
            component: () =>
                import ('@/views/template/components/card'),
            name: 'templateCard',
            hidden: true,
            meta: {
                title: '卡片模板'
            }
        },
        {
            path: 'cardShiXin',
            component: () =>
                import ('@/views/template/components/cardShiXin'),
            name: 'templateCardShiXin',
            hidden: true,
            meta: {
                title: '视信卡片模板'
            }
        },
        {
            path: 'text',
            component: () =>
                import ('@/views/template/components/text'),
            name: 'templateText',
            hidden: true,
            meta: {
                title: '文本模板'
            }
        },
        {
            path: 'media',
            component: () =>
                import ('@/views/template/components/video'),
            name: 'templateVideo',
            hidden: true,
            meta: {
                title: '多媒体模板'
            }
        },
        {
            path: '5GShiXin',
            component: () =>
                import ('@/views/template/5GShiXin'),
            name: '5GShiXin',
            meta: {
                title: '5G视信模板列表'
            }
        },
        {
            path: '5GYueXin',
            component: () =>
                import ('@/views/template/5GYueXin'),
            name: '5GYueXin',
            meta: {
                title: '5G阅信模板列表'
            }
        },
        {
            path: '5GyueXinAdd',
            component: () =>
                import ('@/views/template/components/5GYueXin/add'),
            name: '5GyueXinAdd',
            hidden: true,
            meta: {
                title: '新增5G阅信模板'
            }
        },
        {
            path: 'limitList',
            component: () =>
                import('@/views/template/limitIndex'),
            name: 'limitList',
            meta: {
                title: 'Chatbot管控模板'
            }
        },
        {
            path: 'textlimit',
            component: () =>
                import ('@/views/template/components/textlimit'),
            name: 'textlimit',
            hidden: true,
            meta: {
                title: '管控文本模板'
            }
        },
        {
            path: 'medialimit',
            component: () =>
                import ('@/views/template/components/videolimit'),
            name: 'medialimit',
            hidden: true,
            meta: {
                title: '管控多媒体模板'
            }
        },
        {
            path: 'cardlimit',
            component: () =>
                import ('@/views/template/components/cardlimit'),
            name: 'cardlimit',
            hidden: true,
            meta: {
                title: '管控卡片模板'
            }
        },
    ]
},{
    path: '/shortlink',
    component: Layout,
    name: 'shortlink',
    alwaysShow: true,
    meta: {
        title: '5G阅信短链',
        icon: 'link'
    },
    children: [{
        path: '5GYueXinLink',
        component: () =>
            import ('@/views/shortlink/5GYueXinLink'),
        name: '5GYueXinLink',
        meta: {
            title: '5G阅信短链列表'
        }
    },{
        path: '5GReport',
        component: () =>
            import('@/views/report/5GYuxin'),
          name: '5GReport',
          meta: {
                title: '5G阅信报表'
            }
    }]
},{
    path: '/5gpower',
    component: Layout,
    name: 'powerBy5g',
    alwaysShow: true,
    meta: {
        title: '5G终端验证',
        icon: 'el-icon-mobile-phone'
    },
    children: [{
        path: 'powerVerify',
        component: () =>
            import('@/views/mobileVerify/querymobil'),
        name: 'powerBy5g',
        meta: {
            title: '上传号码',
        }
    },{
        path: 'powerVerifyList',
        component: () =>
            import('@/views/mobileVerify/list'),
        name: 'powerBy5GLog',
        meta: {
            title: '结果文件'
        }
    }]
},{
    path: '/childAccount',
    component: Layout,
    name: "chlidAccount",
    meta: {
        title: '子账号管理',
        icon: 'el-icon-user'
    },
    children: [{
        path: 'sonManager',
        component: () =>
            import('@/views/info/account'),
        name: 'childAccount',
        meta: {
            title: '子账号管理'
        }}
    ]
}, {
    path: '/info',
    component: Layout,
    name: 'baseInfo',
    alwaysShow: true,
    meta: {
        title: '基本信息',
        icon: 'info'
    },
    children: [{
        path: 'rechargeHistory',
        component: () =>
            import ('@/views/info/recharge'),
        name: 'rechargeHistory',
        meta: {
            title: '交易记录'
        }
    },{
        path: 'index',
        component: () =>
            import ('@/views/info/index'),
        name: 'personalInfo',
        meta: {
            title: '个人信息'
        }
    } ]
}, {
    path: '/authinfo',
    component: Layout,
    name: 'UserAuthInfo',
    hidden: true,
    alwaysShow: false,
    meta: {
        title: '认证资料',
        icon: 'info'
    },
    children: [{
        path: 'info',
        component: () =>
            import ('@/views/authinfo/index'),
        name: 'authinfo',
        meta: {
            title: '资料'
        }
    }]
}, {
    path: '*',
    redirect: '/404',
    hidden: true
}, ]
const router = new Router({
    scrollBehavior: () => ({
        y: 0
    }),
    routes: staticRoutes
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

router.matcher = router.matcher;
staticRoutes.forEach(route => {
    router.addRoute(route)
})

const whiteList = ['/login']

// 前置守卫
router.beforeEach(async(to, from, next) => {
    NProgress.start()
    document.title = '用户端 - ' + to.meta.title
    const token = getToken()
    if (!token) {
        // 未登录
        if (whiteList.indexOf(to.path) !== -1) {
            // 白名单内的，直接跳转
            next()
        } else {
            // 没有权限的页面，跳转到登录页面
            next(`/login?redirect=${to.path}`)
        }
    } else {
        // 已登录
        const hasRoutes = store.getters.user.routes && store.getters.user.routes.length > 0
        if (hasRoutes) {
            // 已有路由表
            next()
        } else {
            // 没有路由表
            try {
                const accessRoutes = await store.dispatch('user/getRouteList')
                accessRoutes.forEach(function(route) {
                    router.addRoute(route)
                })
                next({
                    ...to,
                    replace: true
                })
            } catch (error) {
                // 获取路由失败， 删除token，重新登录
                store.dispatch('user/logout')
                Message.error(error || '发生未知错误，请重新登录！')
                next('/login')
                NProgress.done()
            }
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})

export default router
